var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-widget',{attrs:{"title":_vm.$t('New'),"icon":"mdi-progress-wrench","color":"info","stat":_vm.notStartedPlanCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }